import React, { ReactElement, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './Header.less';
import {useDispatch, useSelector} from 'react-redux';
import { Button, Col, Form, Modal, Popover, Row, Tooltip } from 'antd';
import { toTitleCase } from '../../utils/customPipeUtil';
import { RootState } from '../../store';
import { ApplicationDetailModel } from '../../store/models/applicationDetailModel';
import SurveyModal from '../../shared/components/SurveyModal';

import {
  authFeatureConstants,
  HELP_ROUTE,
} from '../../shared/constants/commonConstants';

import { ReactComponent as HelpIcon } from '../../assets/images/svg/i_help.svg';
import { ReactComponent as UserIcon } from '../../assets/images/svg/i_user.svg';
import { ReactComponent as EmailSettingIcon } from '../../assets/images/svg/email-setting.svg';
import IHXLogo from '../leftsidebar/logo/IhxLogo';
import { RetweetOutlined } from '@ant-design/icons';
import ProviderSelectionComponent from '../../shared/components/ProviderSelectionComponent/ProviderSelectionComponent';
import { canActivate, centeredNotification, isSuperAdmin } from '../../utils/utility';
import { MailboxType } from '../../store/models/mailBoxModel';
import PerformanceCard from '../../shared/components/PerformanceCard/PerformanceCard';
import ApplicationDetail from '../../shared/services/applicationDetail.service';
import { customGTMEvent } from '../../modules/crm/inPatient/service/crmUtils';
import Notification from '../../shared/components/Notification';
import EmailVerificationModal from '../../shared/components/EmailVerificationModal/EmailVerificationModal';
import { getTickerConfig, setIsLogOutBtnClicked, setIsLogOutClicked } from '../../store/actions/hospitalAction';
import { fetchNotifications, readNotifications, saveNotifications, updateUnreadAndTotalCount } from '../../store/actions/utilAction';
import useSignalRWebSocket from '../../shared/hooks/useSignalRWebSocket';
import TickerBanner from './HtmlBanner';
import { setEmailVerifyModalShow } from '../../store/actions/mailBoxAction';

const Header = (): ReactElement => {
  const appService = ApplicationDetail.instance;
  const hospitalDetails = appService.getHospitalDetail();
  const groupProviders = JSON.parse(localStorage.getItem('groupProviders') || '{}');
  const providerDetail = JSON.parse(localStorage.getItem('providerDetail') || '{}'); // JSON PARSE error fixed
  const userDetail = JSON.parse(localStorage.getItem('userDetail') || '{}');
  const notificationHubUrl = `${process.env.REACT_APP_CRM_BASE_URL}notify?providerId=${providerDetail?.providerId}&userId=${userDetail?.userId}&isGroupLogin=${groupProviders?.length ? true : false}`;
  const { providerConfigurableProperties } = hospitalDetails || {};
  const { isUserPerformanceCard } = providerConfigurableProperties || {};
  const [selectedHospital, setSelectedHospital] = useState(null as any);
  const [options, setOptions] = useState([] as any);

  const history = useHistory();
  const dispatch = useDispatch();
  const [isProviderModalVisible, setIsProviderModalVisible] = useState(false);
  const [isNotificationPanelVisible, setIsNotificationModalVisible] = useState(false);
  const [isLogOutVisible, setIsLogoutVisible] = useState(false);
  const [isPanelClosing, setIsPanelClosing] = useState(false);
  const [isStopped, setIsStopped] = useState(true);
  const [isPaused, setIsPaused] = useState(true);
  const [unreadNotificationsList, setUnreadNotificationsList] = useState([]);
  const [tickerResponse, setTickerResponse] = useState<any>(null);
  const appDetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );

  const { hospitalConfiguration: emailConfiguration = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { isEmailVerified } = emailConfiguration || {};
  const { totalNotificationUnReadCount, totalNotificationCount } = useSelector((state: RootState): any => state.util) || 0;
  const [aForm] = Form.useForm();

  useEffect((): any => {
    if (localStorage.getItem('isEmailVerificationRequired') === 'true') {
      dispatch(setEmailVerifyModalShow(true));
    }
    localStorage.setItem('isNotificationPanelVisible', 'false');
  }, []);

  const onSuccess = (data: any): any => {
    setTickerResponse(data);
  };
  useEffect((): any => {
    if (appDetails?.getProviderId()) {
      dispatch(getTickerConfig(appDetails?.getProviderId(), onSuccess));
    }
  }, [appDetails?.getProviderId()]);

  useEffect((): void => {
    if (totalNotificationCount || totalNotificationUnReadCount) {
      localStorage.setItem('recentUnreadCount', totalNotificationUnReadCount);
      localStorage.setItem('recentTotalNotificationsCount', totalNotificationCount);
    }
  }, [totalNotificationUnReadCount, totalNotificationCount]);

  useEffect((): void => {
    if (localStorage.getItem('isNotificationEnabled') === 'true' && !isPanelClosing) {
      dispatch(saveNotifications([]));
      if (process.env.REACT_APP_IS_NOTIFICATIONS_ENABLED === 'true' && localStorage.getItem('isNotificationEnabled') === 'true') {
      dispatch(fetchNotifications({ startIndex: 1, searchText: '', range: 10 }));
    }
    }
  }, [isNotificationPanelVisible]);

  const onNotificationReceived = (message: any): any => {
    // Handle received messages
    const isPanelVisible = localStorage.getItem('isNotificationPanelVisible') === 'true' ? true : false;
    setIsStopped(isPanelVisible);
    setIsPaused(isPanelVisible);
    dispatch(updateUnreadAndTotalCount(Number(localStorage.getItem('recentUnreadCount')) + 1, Number(localStorage.getItem('recentTotalNotificationsCount')) + 1));
    if (localStorage.getItem('currentSearchText')?.length) {
      if (message?.content?.toLowerCase()?.includes(localStorage.getItem('currentSearchText')) ||
        message?.title?.toLowerCase()?.includes(localStorage.getItem('currentSearchText'))) {
        dispatch(saveNotifications([message] || [], false, true));
      }
      return;
    }
    dispatch(saveNotifications([message] || [], false, true));
  };

  useSignalRWebSocket(notificationHubUrl, onNotificationReceived);

  const onLogout = (): void => {
    history.replace('/logout');
    dispatch(setIsLogOutClicked(true));
    // dispatch(logout());
  };

  const confirmLogout = (): void => {
    setIsLogoutVisible(true);
    dispatch(setIsLogOutBtnClicked(true));
  };

  const onChangePassword = (): void => {
    history.push('/change-password');
  };

  const content = (
    <div className="user-dropdown-list">
      <div onClick={onChangePassword} className="pointer-on-hover">Change Password</div>
      <div onClick={confirmLogout} className="pointer-on-hover">Logout</div>
    </div>
  );

  const getUserName = (): string => {
    return toTitleCase(appDetails.getUserName() || appDetails.getLoginName() || 'User');
  };

  const getProviderName = (): string => {
    let providerName = '';
    if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
      providerName = appDetails?._applicationDetail?.hospitalDetail?.providerName ||
        appDetails?.getProviderName();
    } else {
      providerName = appDetails.getProviderName();
    }
    return providerName;
  };

  const onResourceNavigation = (): any => {
    history.push(HELP_ROUTE);
  };

  const openProviderChangeModal = (): any => {
    setIsProviderModalVisible(true);
  };

  const onModalCancel = (): any => {
    aForm.resetFields();
    setIsProviderModalVisible(false);
    setSelectedHospital(null);
    setOptions([]);
  };

  const onConfirmModalCancel = (): any => {
    setIsLogoutVisible(false);
    dispatch(setIsLogOutBtnClicked(false));
  };

  const handleOpenNotificationPanel = (): void => {
    customGTMEvent({
      event: isStopped
        ? 'Notification opened when no animation'
        : 'Notification opened when Animation',
    });
    localStorage.setItem('isNotificationPanelVisible', 'true');
    setIsPanelClosing(false);
    setIsNotificationModalVisible(true);
    setIsStopped(true);
    setIsPaused(true);
  };

  const onClose = (): void => {
    if (unreadNotificationsList?.length) {
      dispatch(readNotifications(unreadNotificationsList, onSuccessRead, onFailureRead, false));
    }
    localStorage.setItem('isNotificationPanelVisible', 'false');
    setIsPanelClosing(true);
    setIsNotificationModalVisible(false);
  };

  const onSuccessRead = (): void => {
    setUnreadNotificationsList([]);
  };

  const onFailureRead = (errorMessage: string): void => {
    centeredNotification(errorMessage);
  };

  const transformData = (): any => {
    const messages: any = [];
    let i = 1;
    if (tickerResponse) {
      const colorObject: { [key: string]: string } = {};
      // Continue processing until we no longer find any ticker-related keys
      while (tickerResponse[`ticker${i}Message`] !== undefined ||
        tickerResponse[`ticker${i}CTA`] !== undefined ||
        tickerResponse[`ctA${i}Link`] !== undefined) {
        const message = tickerResponse[`ticker${i}Message`];
        const cta = tickerResponse[`ticker${i}CTA`];
        const link = tickerResponse[`ctA${i}Link`];
        // Check if any of the properties are present and non-empty
        if (message || cta || link) {
          messages?.push({
            id: `ticker${i}`,
            message: message || '',
            cta: cta || '',
            link: link || '',
            ...colorObject,
          });
        }
        i++;
      }
    }

    return messages;
  };

  const ParsingTickercolor = (data: any): any => {
    if (data) {
      const jsonString = data?.['colorObject'];
      const properlyEscapedString = JSON?.parse(`"${jsonString}"`);
      const jsonObject = JSON?.parse(properlyEscapedString);
      return jsonObject;
    }
  };
  const outputTicker = tickerResponse ? transformData() : [];
  const display = tickerResponse ? ParsingTickercolor(tickerResponse) : [];

  return (
    <React.Fragment>
      <header className="header">
        <div className="hospital-info">
          <div className={'navbarLogoBg'}>
           <IHXLogo />
          </div>
          <div className="provider-name">
            {(getProviderName() && getProviderName()?.length > 30) ? (
              <Tooltip title={getProviderName()} placement="bottom">
                {getProviderName()?.substring(0, 30)}
              </Tooltip>
            ) : (
              getProviderName() || ''
            )}
          </div>
        </div>
        {outputTicker?.length > 0 ? <TickerBanner bannerinfo={outputTicker} bannercss={display} /> : <></>}
        <div className="menus">
          <ul className="header-link">
            {
              process.env.REACT_APP_IS_NOTIFICATIONS_ENABLED === 'true' && localStorage.getItem('isShowNotificationIcon') === 'true' &&
              <li>
                  <Notification isNotificationPanelVisible={isNotificationPanelVisible}
                    onClose={onClose} handleOpenNotificationPanel={handleOpenNotificationPanel}
                    totalNotificationUnReadCount={totalNotificationUnReadCount} isStopped={isStopped} isPaused={isPaused}
                    setUnreadNotificationsList={setUnreadNotificationsList} unreadNotificationsList={unreadNotificationsList} />
              </li>
            }
            {
              (isUserPerformanceCard && canActivate(authFeatureConstants.PERFORMANCE_CARD)) &&
              <li><PerformanceCard /></li>
            }

            {
              !isEmailVerified && canActivate(authFeatureConstants.EDIT_MAILBOX) &&
              <Tooltip title="Manage Claims from all payers" placement="bottom">
                <Button
                  className="blink-btn"
                  id="manage-payer-header-track"
                  type="ghost"
                  shape="round"
                  onClick={(): any => history.push('/profile/mailbox')}
                  icon={<EmailSettingIcon />}>
                  &nbsp;Manage Payers
                </Button>
              </Tooltip>
            }
            {canActivate(authFeatureConstants.CHANGE_HOSPITAL) &&
              isSuperAdmin() && (
                <li>
                  <Tooltip title="Change provider" placement="bottom">
                    <RetweetOutlined
                      data-testid="change-hospital"
                      className="change-hospital"
                      onClick={openProviderChangeModal}
                    />
                  </Tooltip>
                </li>
              )}
            {canActivate(authFeatureConstants.RESOURCES) &&
              <li
                className="a"
                onClick={onResourceNavigation}
              >
                <Tooltip title="User Guidelines" placement="bottom">
                  <HelpIcon />
                </Tooltip>
              </li>
            }
            <Popover
              placement="bottomRight"
              title={<strong>{getUserName()}</strong>}
              content={content}
              trigger="hover"
            >
              <li className="user-profile">
                <UserIcon />
              </li>
            </Popover>
          </ul>
        </div>
      </header>
      <Modal
        visible={isProviderModalVisible}
        title="Change hospital"
        onCancel={onModalCancel}
        footer={null}
      >
        <ProviderSelectionComponent
          form={aForm}
          selectedHospital={selectedHospital}
          setSelectedHospital={setSelectedHospital}
          options={options}
          setOptions={setOptions}
          onModalCancel={onModalCancel}
        />
      </Modal>
      <Modal
        visible={isLogOutVisible}
        onCancel={onConfirmModalCancel}
        title={'Confirmation to Logout'}
        footer={null}
      >
        <Row>
          Are you sure you want to logout? If yes, click on Proceed to continue, else click on Cancel
        </Row>
        <Row gutter={8} className="logoutButtonDiv">
          <Col>
            <Button key="close" type="default" onClick={(): any => {
              setIsLogoutVisible(false);
              dispatch(setIsLogOutBtnClicked(false));
            }
            }>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button key="submit" type="primary" onClick={(): any => {
              onLogout();
            }}>
              Proceed
            </Button>
          </Col>
        </Row>
      </Modal>
      {(process.env.REACT_APP_IS_ASK_FOR_SURVEY === 'true' || process.env.REACT_APP_IS_MULTIPAYER_FOR_SURVEY === 'true') &&
        <SurveyModal />
      }
      <EmailVerificationModal />
    </React.Fragment>
  );
};

export default Header;
